import {
  AvatarNew,
  Button,
  CountryIcon,
  Icon,
  ISO3166Alpha2Code,
  PillBadge,
} from '@platform/components';
import { ROUTES } from '../../routes/consts';
import {
  MyCohortMemberDetailAvatarUrl,
  MyCohortMemberDetailCountry,
  MyCohortMemberDetailEmployer,
  MyCohortMemberDetailPositionTitle,
} from '@platform/client/schemas';

export const MemberCard = ({
  name,
  avatarUrl,
  positionTitle,
  employer,
  country,
  countryAlpha2,
  skills,
  userId,
}: {
  name: string;
  avatarUrl: MyCohortMemberDetailAvatarUrl;
  positionTitle: MyCohortMemberDetailPositionTitle;
  employer: MyCohortMemberDetailEmployer;
  country: MyCohortMemberDetailCountry;
  countryAlpha2: ISO3166Alpha2Code;
  skills: string[];
  userId: number;
}) => {
  return (
    <div className='w-full h-full bg-white rounded-lg shadow-sm p-5 border border-gray-100 flex flex-col'>
      <div className='flex gap-3 mb-3'>
        <AvatarNew size='xl' url={avatarUrl} alt={`Avatar of ${name}`} name={name} />
        <div className='flex-1'>
          <h3 className='text-md font-semibold text-gray-700'>{name}</h3>
          <p className='text-sm font-base text-gray-700'>{positionTitle}</p>
          <p className='text-sm font-base text-gray-400'>{employer}</p>
          <div className='text-sm font-base text-gray-400 flex items-center gap-1'>
            <CountryIcon alpha2={countryAlpha2} height={16} />
            <p>{country}</p>
          </div>
        </div>
      </div>
      <div className='flex-1 mb-3.5'>
        <div className='flex flex-wrap gap-2 content-start'>
          {skills.map((skill) => (
            <PillBadge key={skill} variant='plain' size='sm' color='gray'>
              {skill}
            </PillBadge>
          ))}
        </div>
      </div>
      <Button
        variant='secondary-gray'
        size='sm'
        href={`/platform${ROUTES.DIRECTORY}${ROUTES.DIRECTORY_PROFESSIONALS.replace(':userId', userId.toString())}`}
      >
        See Profile
        <Icon type='arrow-right' size='15' />
      </Button>
    </div>
  );
};
